import { render } from "./ProfileHeader.vue?vue&type=template&id=463f8573"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__